// Fix for cart quantity update error
// This patches the getQuantityBreaks method to handle undefined rulesets

(function() {
  // Wait for DOM and custom elements to be ready
  function patchCartItemPrice() {
    const cartItemPriceElements = document.querySelectorAll('cart-item-price');
    
    cartItemPriceElements.forEach(element => {
      // Override the getQuantityBreaks method to add null check
      if (element.getQuantityBreaks) {
        const originalGetQuantityBreaks = element.getQuantityBreaks.bind(element);
        
        element.getQuantityBreaks = function(ruleset) {
          // Check if ruleset exists and has rules property
          if (!ruleset || !ruleset.rules) {
            console.warn('Ruleset is undefined or missing rules property', ruleset);
            return [];
          }
          
          // Call original method if ruleset is valid
          return originalGetQuantityBreaks(ruleset);
        };
      }
      
      // Also patch updatePriceBasedOnQuantity to handle missing rulesets
      if (element.updatePriceBasedOnQuantity) {
        const originalUpdatePrice = element.updatePriceBasedOnQuantity.bind(element);
        
        element.updatePriceBasedOnQuantity = function(cartItem) {
          try {
            // Check if rulesSets exists
            if (!this.rulesSets || !Array.isArray(this.rulesSets)) {
              console.warn('No rulesSets available for cart item', cartItem);
              return;
            }
            
            // Call original method
            return originalUpdatePrice(cartItem);
          } catch (error) {
            console.error('Error updating price based on quantity:', error);
          }
        };
      }
    });
  }
  
  // Apply patches when DOM is ready and after cart updates
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchCartItemPrice);
  } else {
    patchCartItemPrice();
  }
  
  // Re-apply patches after cart updates (Shopify cart:change event)
  document.addEventListener('cart:change', function() {
    setTimeout(patchCartItemPrice, 100);
  });
  
  // Also listen for custom element upgrades
  if (window.customElements) {
    const originalDefine = window.customElements.define;
    window.customElements.define = function(name, constructor, options) {
      originalDefine.call(this, name, constructor, options);
      
      if (name === 'cart-item-price') {
        setTimeout(patchCartItemPrice, 0);
      }
    };
  }
})();